import { fork} from 'redux-saga/effects';
import compApproverData from './compApproverData/sagas';



export default function* rootSaga(getState) {
  yield fork(compApproverData)

  // yield all([
  
  // ]);
}
